import {Branch} from "@/model/branch";

export interface ICustomerPhone {
    customer_phone_id: string;
    branch_id: string;
    phone_number: string;
    name: string | null;
    is_new: boolean;
    origin: string;
    create_at: string;
    deleted_at: string | null;
}

export class CustomerPhone {
    constructor(readonly branch: Branch, readonly meta: ICustomerPhone) {
    }

    async update(name: string, phone_number: string, wqs: string): Promise<void> {
        return
    }
}